import { RestrictedByTooltip } from "components";
import { Button } from "components/buttons/button/Button";
import { RolePermissions } from "enums";
import Restricted from "features/Application/Restricted";
import { useNavigate } from "react-router";

export const CreateCampaignButton = () => {
  const navigate = useNavigate();

  const onCreateBtnClick = () => navigate("create");

  const renderCreateCampaignButton = (hasAnyPermission: boolean): React.ReactElement => (
    <RestrictedByTooltip hasPermission={hasAnyPermission}>
      <Button primary onClick={onCreateBtnClick} disabled={!hasAnyPermission} className="create-button">
        Create Campaign
      </Button>
    </RestrictedByTooltip>
  );

  return (
    <Restricted
      permissions={[RolePermissions.CampaignsManage]}
      renderContent={(hasAnyPermission: boolean) => renderCreateCampaignButton(hasAnyPermission)}
    />
  );
};
